import { createTheme } from '@mui/material/styles';
import { themeSettings } from '../theme/index';

const theme = createTheme({ ...themeSettings });

export default theme;
